module.exports = __webpack_public_path__ + "static/img/my-account.158ba346.png";